import React from 'react'
import Footer from '../footer/Footer';
import Header from '../header/Header';
import Main from './main/Main';
import WebSocketContextProvider from '../../providers/WebSocketContextProvider';
import ConfigStepsContextProvider from '../../providers/ConfigStepsContextProvider';
import { ConfigsDataContextProvider } from '../../providers/ConfigsDataContextProvider';
import { FolderListenerContextProvider } from '../../providers/FolderListenerContextProvider';
import { OrganListenerContextProvider } from '../../providers/OrganListenerContextProvider';
import { ItemListenerContextProvider } from '../../providers/ItemListenerContextProvider';
import { TasksContextProvider } from '../../providers/TasksContextProvider';
import { TaskListenerContextProvider } from '../avoda/TaskListenerContextProvider';
import './Layout.css';

export default function Layout() {

  return (

              
                <ConfigsDataContextProvider>          

                      <WebSocketContextProvider>
                        
                        <OrganListenerContextProvider>

                          <ConfigStepsContextProvider>
                            {/* <BreadCrumbsContextProvider> */}

                                <FolderListenerContextProvider>
                                    <ItemListenerContextProvider>

                                      <TasksContextProvider>
                                          <TaskListenerContextProvider>

                                            <div className='layout'>
                                              <Header />
                                              <Main />
                                              <Footer />
                                            </div>

                                          </TaskListenerContextProvider>
                                      </TasksContextProvider>
                                    </ItemListenerContextProvider>
                                </FolderListenerContextProvider>

                            {/* </BreadCrumbsContextProvider> */}
                          </ConfigStepsContextProvider>

                        </OrganListenerContextProvider>

                      </WebSocketContextProvider>

                </ConfigsDataContextProvider>              
  )
}